import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-communication-alert-notification-widget',
  templateUrl: './communication-alert-notification-widget.component.html',
  styleUrls: ['./communication-alert-notification-widget.component.scss']
})
export class CommunicationAlertNotificationWidgetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
